<script>
//import store from '../store';
import SelectDropdown from './SelectDropdown.vue';
import InfoCard from './InfoCard.vue';

export default {
    name: "ProjectsDropdown",
    components: {
        SelectDropdown,
        InfoCard,
    },
    props: {
        modelValue: {
            type: [Array, String, Number, Object, null],
            required: true
        },
        showInfoCard: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: 'Select Projects'
        },
        maxSelection: {
            type: Number,
            default: Infinity
        },
        disabled: {
            type: Boolean,
            default: false
        },
        multi: {
            type: Boolean,
            default: true
        },
        memberId: {
            type: [String, Number, null],
            default: null
        },
        isAI: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        },
        textLimit: {
            type: [Number, String],
            default: Infinity
        },
        context: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            searchQuery: '',
            selectedSegment: 'All Segments',
            dateFrom: '',
            dateTo: '',
            debouncedSearch: null
        };
    },
	mounted(){
		console.log("In ProjectsDropdown mounted projects");
		console.log(this.$store.state.projects);
	},
    computed: {
        projects() {
            if (this.memberId) {
                return (this.$store.state.memberProjects[this.memberId] && this.$store.state.memberProjects[this.memberId].data) || [];
            }
            return (this.$store.state.projects && this.$store.state.projects.data) || [];
        },
        projectsPagination() {
            if (this.memberId) {
                return (this.$store.state.memberProjects[this.memberId] && this.$store.state.memberProjects[this.memberId].pagination) || {};
            }
            return (this.$store.state.projects && this.$store.state.projects.pagination) || {};
        },
        ProjectsLoading() {
            if (this.memberId) {
                return this.$store.state.loading.memberProjects[this.memberId] || false;
            }
            return this.$store.state.loading.project;
        },
        projectsList() {
            return this.projects
                .map((item) => ({
                    label: item.projectName,
                    value: item.projectId,
                    marketSegment: item.marketSegment,
                    completionDate: item.constructionCompletionDate
                }))
                .filter(Boolean);
        },
        selectedProjectIds() {
            if (!this.modelValue) return this.multi ? [] : null;
            if (this.multi) {
                return this.modelValue.map((p) => p.projectId);
            } else {
                return this.modelValue[0] ? this.modelValue[0].projectId : null;
            }
        },
        canPaginate() {
		    console.log("In canPaginate this.projectsPagination");
			console.log(this.projectsPagination);
			console.log(this.$store.state.projects);
            return ((this.projectsPagination && this.projectsPagination.page) || 0) < ((this.projectsPagination && this.projectsPagination.totalPages) || 0);
        }
    },
    watch: {
        searchQuery() {
            if (!this.debouncedSearch) {
                this.debouncedSearch = this.debounce(() => {
                    this.fetchProjectsList(1);
                }, 500);
            }
            this.debouncedSearch();
        }
    },
    methods: {
        debounce(fn, delay) {
            let timeoutId;
            return (...args) => {
                if (timeoutId) clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    fn(...args);
                }, delay);
            };
        },
        async fetchProjectsList(page = 1) {
            await this.$store.dispatch('fetchProjects', {
                page,
                search: this.searchQuery,
                marketSegmentId: this.selectedSegment,
                from: this.dateFrom,
                to: this.dateTo,
                teamMemberId: this.memberId
            });
        },
        handleApplyFilters() {
            this.fetchProjectsList(1);
        },
        handleResetFilters() {
            this.searchQuery = '';
            this.selectedSegment = 'All Segments';
            this.dateFrom = '';
            this.dateTo = '';
            this.fetchProjectsList(1);
        },
        handleProjectSelection(selectedIds) {
            if (this.multi) {
                const selectedProjects = (selectedIds || [])
                    .map(id => {
                        const existing = this.modelValue && this.modelValue.find(p => p.projectId === id);
                        if (existing) return existing;

                        const p = this.projects.find(p => p.projectId === id);
                        if (p) return { ...p, projectDetails: p.projectDetails || "" };
                        return null;
                    })
                    .filter(Boolean);
                this.$emit('update:modelValue', selectedProjects);
            } else {
                if (!selectedIds) {
                    this.$emit('update:modelValue', []);
                    return;
                }
                let selectedProject = this.modelValue && this.modelValue.find(p => p.projectId === selectedIds);
                if (!selectedProject) {
                    const p = this.projects.find(p => p.projectId === selectedIds);
                    selectedProject = p ? { ...p, projectDetails: p.projectDetails || "" } : null;
                }
                this.$emit('update:modelValue', selectedProject ? [selectedProject] : []);
            }
        },
        removeProject(projectId) {
            if (this.multi) {
                const updatedProjects = this.modelValue.filter(p => p.projectId !== projectId);
                this.$emit('update:modelValue', updatedProjects);
            } else {
                this.$emit('update:modelValue', []);
            }
        },
        handleReorderProjects({ from, to }) {
            if (!this.multi) return;
            const projects = [...this.modelValue];
            if (from < 0 || to < 0 || from >= projects.length || to >= projects.length) return;
            const [moved] = projects.splice(from, 1);
            projects.splice(to, 0, moved);
            this.$emit('update:modelValue', projects);
        },
        handlePagination() {
            this.fetchProjectsList(((this.projectsPagination && this.projectsPagination.page) || 0) + 1);
        }
    }
};
</script>


<template>
    <div>
        <SelectDropdown :modelValue="selectedProjectIds" :options="projectsList" :projectFilters="true" :multi="multi"
            :show-search="true" :placeholder="placeholder" @update:modelValue="handleProjectSelection"
            :loading="ProjectsLoading" :canPaginate="canPaginate" @handlePagination="handlePagination"
            :maxSelection="maxSelection" :disabled="disabled" :isClearable="true" :searchQuery.sync="searchQuery"
            :selectedSegment.sync="selectedSegment" :dateFrom.sync="dateFrom" :dateTo.sync="dateTo"
            @apply-filters="handleApplyFilters" @reset-filters="handleResetFilters" :label="label" />

        <div v-if="showInfoCard && modelValue.length > 0" class="mt-2">
            <InfoCard :list="modelValue" @remove-item="removeProject" @move-item="handleReorderProjects" :isAI="isAI"
                :textLimit="textLimit" :context="context" @update="$emit('update:modelValue', $event)" />
        </div>
    </div>
</template>